export { TrigallHero, type TrigallHeroProps } from './TrigallHero';
export { trigallHeroSchema } from './schema';
